import { Polyline, Path } from '../../geometry';
export const normal = function (sourcePoint, targetPoint, routePoints) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const points = [sourcePoint, ...routePoints, targetPoint];
  const polyline = new Polyline(points);
  const path = new Path(polyline);
  return options.raw ? path : path.serialize();
};